/**
 * Product identity shown in the UI. The name is configurable per deployment
 * (`VITE_PRODUCT_NAME`) so no company name is baked into the code.
 */
export const PRODUCT_NAME: string = import.meta.env['VITE_PRODUCT_NAME'] || 'CRM';

/** Build version shown to support. Kept literal so `package.json` stays out of the bundle. */
export const APP_VERSION = '0.0.1';
